
import "bootstrap/dist/css/bootstrap.min.css";
import { FaMapMarkerAlt, FaCalendarAlt, FaBriefcase, FaBook, FaClock } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import React, { useEffect,  } from "react";
import hero1 from "../assets/carrer.png";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CareerDetails() {
     // Initialize AOS animations
      useEffect(() => {
        AOS.init({
          duration: 1000,
        });
      }, []);
  return (
    <div>
         {/* Hero Section */}
      <div className="container-fluid p-0">
       <div
  className="hero-section"
  style={{ backgroundImage: `url(${hero1})` }}
>
          <div
            className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100"
            data-aos="fade-up"
          >
            <div className="col-lg-10">
              <h1 className="display-4 fw-bold text-light mb-4">
                Career
              </h1>
            </div>
          </div>
        </div>
      </div>
    <div className="container my-5">
        
      <div className="row">
        {/* Left Column - Job Description */}
        <div className="col-lg-8 col-md-7 col-12"    data-aos="fade-up"
      data-aos-delay="200">
          <h2 className="fw-bold mb-4" style={{ color: "#001833" }}>Wordpress Developer</h2>

          <section className="mb-4">
            <h5 className="fw-bold mb-3 career-subheading">Who Are We Looking For</h5>
            <ul className="career-list">
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
              <li>Nullam dictum ligula a gravida porta.</li>
              <li>Nam pellentesque orci ut odio blandit.</li>
              <li>Vivamus semper magna suscipit leo malesuada.</li>
              <li>Integer et felis a purus convallis condimentum nec vel eros.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold mb-3 career-subheading">What You Will Be Doing</h5>
            <ul className="career-list">
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
              <li>Nullam dictum ligula a gravida porta.</li>
              <li>Nam pellentesque orci ut odio blandit.</li>
              <li>Vivamus semper magna suscipit leo malesuada.</li>
              <li>Cras ut erat eu ante suscipit rutrum.</li>
            </ul>
          </section>

          <section>
            <h5 className="fw-bold mb-3 career-subheading">The Application Process</h5>
            <ul className="career-list">
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
              <li>Nullam dictum ligula a gravida porta.</li>
              <li>Nam pellentesque orci ut odio blandit.</li>
              <li>Vivamus semper magna suscipit leo malesuada.</li>
              <li>Nulla non enim eu quam rutrum dictum in non urna.</li>
            </ul>
          </section>
        </div>

        {/* Right Column - Job Summary */}
    <div className="col-lg-4 col-md-5 col-12"   data-aos="fade-up"
      data-aos-delay="400">
  <div className="card shadow-sm p-4 job-summary-card">
    <button className="btn btn-danger w-100 mb-4 fs-5">Apply Now</button>
    <h5 className="fw-bold mb-3 fs-4">Job Summary</h5>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <FaMapMarkerAlt className="text-danger job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">Location:</span>
          Tower International Group, LLC, Office 204, 2nd Floor,
          Al Assalah Towers, Muscat, Sultanate of Oman
        </p>
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <FaBriefcase className="text-primary job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">Job Type:</span>
          Full Time
        </p>
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <FaCalendarAlt className="text-success job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">Date Posted:</span>
          1 month ago
        </p>
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <FaBook className="text-warning job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">Experience:</span>
          3 Years
        </p>
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <FaClock className="text-info job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">Working Hours:</span>
          9 AM - 6 PM
        </p>
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <MdWork className="text-secondary job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">Working Days:</span>
          Weekly 5 days <br/>
         (Fri, Sat weekend)
        </p>
      </div>
    </div>

    <div className="row mb-3">
      <div className="col-auto d-flex align-items-start">
        <MdWork className="text-dark job-icon-lg" />
      </div>
      <div className="col ps-0">
        <p className="mb-0 job-text-lg">
          <span className="job-label d-block">No. of Vacancies:</span>
          3
        </p>
      </div>
    </div>

    <a href="#" className="fw-bold job-link-lg">View all jobs</a>
  </div>
</div>





      </div>
    </div>
    </div>
  );
}
